export default __webpack_public_path__ + "static/media/lds-logo_pt.274da5f3e244b0f8.svg";